import { Component, Input } from '@angular/core';
@Component({
	selector: 'app-projeto-tab',
  	templateUrl: './tab.component.html',
  	styleUrls: ['./tab.component.scss']
})
export class ProjetoTabComponent{
	@Input() desativado:boolean = false;;
}
